export default __webpack_public_path__ + "static/media/29.c3981b39.jpg";